import { createAction } from 'redux-actions';

// ------------------------------------
// Actions
// ------------------------------------
export const getTopicsHash: any = createAction('topics/GET_TOPICS_HASH', (topics: State.Topics) => () => {
  return topics;
});
